<template>
  <div class="meorder">
    <!-- 订单 -->
    <div class="meorder_box">

      <div class="meorder_tab">
        <div class="meorder_tabitem" :class="[tabid ==index?'meorderactive':'']" v-for="(item,index) in tabarr" @click="meordertab(index)">
          {{item}}
        </div>
      </div>
      <div class="meorder_none" v-if="meorderarr.length==0">您还没有相关订单</div>
      <div class="car_list" v-else  v-for="(items,indexs) in meorderarr" :key="indexs">
        <div class="car_list_tit">
          <div>
            {{items.create_time}}
          </div>
          <div>
            订单号：{{items.order_sn}}
          </div>
          <div>
           {{items.order_status_show}}
          </div>
        </div>
        <div class="car_item" v-for="(item,index) in items.goods">
          <div class="car_img">
            <img v-if="item.goods_sku_spec_show=='单规格'" :src="[item.goods_img]" alt="">
            <img v-else :src="[item.goods_sku_image]" alt="" srcset="">
            <div class="car_content">
              <div class="car_name txt-cut2">
                {{item.goods_name}}
              </div>
              <div class="car_drop">
                <span class="car_price">￥{{item.goods_sku_price}}</span><span class="car_num">x{{item.goods_num}}</span>
              </div>
            </div>

          </div>
          <div class="meorder_detail">
            <div v-if="items.order_status==3">
              <span style="color: red;" v-if="orderstatus.current_order_status=='评价' || orderstatus.current_order_status=='全部'">{{item.is_evaluate==0?'未评价':'已评价'}}</span>
              <span style="color: red;" v-if="orderstatus.current_order_status=='售后' || orderstatus.current_order_status=='全部'">{{item.is_after_sales==0?'未申请':'已申请'}}</span>
            </div>
            <span @click="pageurl(items.order_id)">订单详情</span>
          </div>
        </div>
        <div class="meorder_price">
            <div class="price_left">
              {{items.coupon_price=="0.00"?'无优惠':'优惠'+items.coupon_price}}
            </div>
            <div class="price_pay">
              共计{{items.total_num}}件，合计<span>￥{{items.order_price}}</span>
            </div>
        </div>
        <div class="meorder_btns" v-if="items.order_status==0||items.order_status==1||items.order_status==2">
          <div class="meorder_btn" v-if="items.order_status==0" @click="payoredrfn(items.order_id)">
           立即支付
          </div>
          <div class="meorder_btn" v-if="items.order_status==0" @click="cancelorderfn(items.order_id)">
            取消订单
          </div>
          <div class="meorder_btn" v-if="items.order_status==1" @click="urgeorderfn(items.order_id)">
            催发货
          </div>
          <div class="meorder_btn" v-if="items.order_status==2" @click="completeorderfn(items.order_id)">
            确认收货
          </div>
        </div>

      </div>
      <el-pagination
            v-if="meorderarr.length>0"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="page_size"
            layout="total, prev, pager, next, jumper"
            :total="orderstatus.total">
      </el-pagination>

    </div>
    <!-- 热门商品 -->
    <!-- <div class="list">
      <div class="list_tit">
        <div class="list_left">自营商品</div>
        <div class="list_many"></div>
      </div>
      <div class="list_box">
        <div class="list_item" v-for="item in 5" @click="pageurl('/detail')">
          <div class="item_img">
            <img src="../../../assets/list_img.png">
          </div>
          <div class="list_info">
            <div class="list_name txt-cut3">黄蜡石，风水镇宅家摆件都配上.....</div>
            <div class="list_price">￥778</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import {getmeorderapi,payorderapi,cancelorderapi,urgeorderapi,completeorderapi} from "../../../api/http.js"
  export default {
    name: "meorder",
    data() {
      return {
        tabarr:[ "全部","待付款","待发货","待收货","评价","售后"],
        tabid:0,
        page:1,
        page_size:5,
        meorderarr:[],
        orderstatus:[],
        order_status:-1
      }
    },
    created() {
      this._getmeorder({
        order_status:this.order_status,
        page_size:this.page_size,
        page:this.page
      })
    },
    methods: {
      // 立即支付
     async payoredrfn(id){
       this.$router.push({
         path:"/pay?order_id=" + id
       })
        // console.log(id);
        // const res = await payorderapi({order_id:id})
        // if(res.data.code==200){
        //     this.$message("支付成功")
        //     this._getmeorder({
        //       order_status:this.order_status,
        //       page_size:this.page_size,
        //       page:this.page
        //     })
        // }else if(res.data.code==400){
        //   this.$message("余额不足")
        //   this.$router.push({
        //     path:"/layout/balance"
        //   })
        // }else{
        //   this.$message("支付失败")
        // }
      },
      //取消订单
     async cancelorderfn(id){
       console.log(id);
        const res = await cancelorderapi({order_id:id})
        if(res.data.code==200){
          this.$message("取消成功")
          this._getmeorder({
            order_status:this.order_status,
            page_size:this.page_size,
            page:this.page
          })
        }else{
          this.$message("失败")
          this._getmeorder({
            order_status:this.order_status,
            page_size:this.page_size,
            page:this.page
          })
        }
      },
      // 催发货
     async urgeorderfn(id){
      const res = await urgeorderapi({order_id:id})
        if(res.data.code==200){
         this.$message(res.data.msg)
        }else{
          this.$message(res.data.msg)
        }
      },
      // 确认收货
     async completeorderfn(id){
        const res = await completeorderapi({order_id:id})
        if(res.data.code==200){
          this.$message(res.data.msg)
          this._getmeorder({
            order_status:this.order_status,
            page_size:this.page_size,
            page:this.page
          })
        }else{
          this.$message(res.data.msg)
        }
      },
      pageurl(order_id) {
        this.$router.push({
          path: "/orderdetail",
         query: {
           order_id: order_id,
           orderstatus:this.orderstatus.current_order_status
         }
        })
      },
      // 分页数据
      handleCurrentChange(val){
        this._getmeorder({
          order_status:this.order_status,
          page_size:this.page_size,
          page:val
        })
      },
      // 订单分类的切换
      meordertab(index){
       this.tabid =index
       this.orderstatus= []
       this.meorderarr = []
       this.order_status= index-1
       this._getmeorder({
        order_status:this.order_status,
        page_size:this.page_size,
        page:this.page
      })
      },
      // 订单数据的请求
     async _getmeorder({order_status,page_size,page}){
        const res = await getmeorderapi({
          order_status,
          page_size,
          page
        })
        console.log(res.data.data);
        console.log(res.data.data.order.data);
        if(res.data.code==200){
          this.orderstatus= res.data.data.order
          this.meorderarr = res.data.data.order.data
        }else{
          this.orderstatus=[]
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import url(../../../../static/index.less);

  .meorder {
    width: 100%;

    .meorder_box {
      width: 100%;

      .meorder_tab {
        width: 100%;
        height: 57px;
        padding: 18px 0;
        box-sizing: border-box;
        border: 0.5px solid #CCCDCE;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .meorderactive{
          color: #FF4444;
        }
        .meorder_tabitem {
          flex: 1;
          text-align: center;
          cursor: pointer;
          border-right: 1px solid #CCCDCE;
        }
      }
      .meorder_none{
        width: 100%;
        height: 200px;
        border-right: 1px solid #CCCDCE;
        color: #292929;
        background: rgba(196, 196, 196, 0.11);
        display: flex;
        font-size: 16px;
        justify-content: center;
        align-items: center;
      }
      .car_list {
        margin-bottom: 20px;

        .car_list_tit {
          width: 100%;
          height: 38px;
          background: #EAF8FF;
          border: 0.5px solid #9EDFFF;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            width: 33%;
            padding-left: 80px;

            &:nth-of-type(3) {
              text-align: right;
              color: #FF4444;
            }
          }

        }

        .meorder_btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          padding-right: 20px;
          padding-top: 20px;
          box-sizing: border-box;

          .meorder_btn {
            margin-left: 10px;
            width: 90px;
            height: 40px;
            background: #FF4444;
            border: 1px solid #FF4444;
            border-radius: 4px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
          }
        }
        .meorder_price{
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          .price_left{
            color: #292929;
          }
          .price_pay{
            color: #CCCDCE;
            span{
              color: #FF4444;
              font-size: 16px;
            }
          }
        }
        .car_item {
          width: 100%;
          height: 120px;
          border: 1px solid #CCCDCE;
          border-top: none;
          display: flex;
          justify-content: space-between;
          align-items: center;

          &:last-child{
            margin-bottom: 10px;
          }
          .car_img {
            width: 620px;
            height: 100%;
            padding: 20px 40px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;

            img {
              width: 80px;
              height: 80px;
              border-radius: 4px;
            }

            .car_content {
              padding-left: 10px;
              box-sizing: border-box;
              flex: 1;
              display: flex;
              justify-content: space-between;
              flex-direction: column;

              .car_name {
                font-size: 16px;
                line-height: 22px;
                height: 44px;
                color: #292929;
                padding-left: 10px;
              }

              .car_drop {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .car_price {
                  font-size: 16px;
                  color: #FF4444;
                }

                .car_num {
                  color: #292929;
                }
              }
            }

          }

          // .meorder_name {
          //   flex: 1;
          //   height: 100%;
          //   display: flex;
          //   justify-content: center;
          //   align-items: center;
          //   border-right: 1px solid #CCCDCE;
          // }

          .meorder_detail {
            border-left: 1px solid #CCCDCE;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            span {
              margin: 5px 0;
              cursor: pointer;
            }
          }


        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/view/meorder.vue